import type { CorsRule } from '@/entities/bucket';
import request from '@/shared/api/request';

export const createBucketCors = (
  name: string,
  data: {
    allowed_origin: string;
    allowed_method: string[];
    allowed_header: string[];
    max_age_seconds: number;
  },
): Promise<{ corsRule: CorsRule }> =>
  request({
    url: `/buckets/${name}/cors/`,
    method: 'POST',
    data,
  });
